import React, { Fragment } from "react";
import { Helmet } from "react-helmet";
import Header from "../layouts/Headerfour";
import Breadcrumb from "../layouts/Breadcrumb";
import Footerthree from "../layouts/Footerthree";
import Footer from "../layouts/Footerthree";
import Content from "../sections/pricing/Content";
import { useTranslation } from "react-i18next";

const Sellproperty = () => {
  const {t}=useTranslation();
  return (
    <Fragment>
      <Helmet>
        <title>Buy Home For Less | Sell Your Property To Us </title>
        <meta name="description" content="#" />
      </Helmet>
      <Header />
      <Breadcrumb breadcrumb={{ pagename: t("sell_property") }} />
      <Content />
      <Footer />
    </Fragment>
  );
};

export default Sellproperty;

